import { useAppNetwork } from "contexts/OfflineContext";
import { useEffect } from "react";
import CacheManager from "./classes/CacheManager";

const CacheProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { isOnline } = useAppNetwork();

  useEffect(() => {
    // When offline, stop all caching
    if (!isOnline) {
      CacheManager.stopAll();
    }
  }, [isOnline]);

  return <>{children}</>;
};

export default CacheProvider;
